module.exports = __webpack_public_path__ + "static/media/no-redeem.e5d5d0bf.png";